import * as sessionUtils from './sessionUtils';
import { goBackIfLoanTypeNotEnabled } from './routingUtils';
import { storeInitialLoanType } from './onboardingRoutingUtils';
import * as queryString from 'query-string';

const goBackIfAutoDisabled = goBackIfLoanTypeNotEnabled('AUTO');

// for auto-related routes, there is no complex onEnter logic (unlike mortgage
// onboarding), because the user can easily go back and forth between states.
// but we should still check for the AUTO loanType and save query params
export function autoOnEnter(nextState) {
  const query = queryString.parse(nextState.location.search);

  goBackIfAutoDisabled(nextState);

  sessionUtils.saveQueryToSession(query);
  storeInitialLoanType(query);
}
